"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALKTHROUGH_PAGE_START_STEP = void 0;
exports.clampStep = clampStep;
exports.openingStep = openingStep;
exports.canGoBack = canGoBack;
exports.closeTourOutcome = closeTourOutcome;
exports.closeOutcome = closeOutcome;
/**
 * "How Fomo-Fi works" (doc 3 "The walkthrough overlay", E1-E16; Paul 2026-10-28): the
 * pure rules behind the overlay, shared so web and mobile open, step and close it the
 * same way. Where the step is remembered (the account when signed in, this device's
 * storage when not) stays with each app.
 */
const walkthroughCopy_1 = require("./walkthroughCopy");
/** Clamp anything to a real step (1-10). */
function clampStep(step) {
    if (step == null || !Number.isFinite(step))
        return 1;
    return Math.min(walkthroughCopy_1.WALKTHROUGH_STEP_COUNT, Math.max(1, Math.trunc(step)));
}
/**
 * Addendum R6 / doc 3 E9: the step each page opens at when nothing is saved. Splash and
 * sign-up 1-3: step 1; Analysis: step 2; Plan: step 3 (the prototype's `startAt`).
 */
exports.WALKTHROUGH_PAGE_START_STEP = {
    splash: 1,
    account: 1,
    payment: 1,
    bank: 1,
    analysis: 2,
    plan: 3,
};
/**
 * Doc 3 E9/E10: open "at the step for where the user is, or at the step they stopped
 * at last time". A saved step wins over the page's step, except for a deep link (an
 * "i" bubble or page link, E12), which always opens at its own step.
 */
function openingStep(o) {
    if (o.deepLink)
        return clampStep(o.pageStep);
    return o.savedStep != null ? clampStep(o.savedStep) : clampStep(o.pageStep);
}
/** E7 / addendum R5: Back is disabled on step 1. */
function canGoBack(step) {
    return clampStep(step) > 1;
}
/**
 * Addendum R4 / R6, word for word from Anthony's prototype (`closeTour` and step 10's
 * `next`): what closing the overlay leaves saved.
 *
 * - Finishing (step 10's "Done · back to [page]") clears the saved step and is the
 *   completion (G5).
 * - Any other close saves the step ONLY if the user moved past where this opener starts
 *   (`startStep`, the page's step) and isn't on step 10. Otherwise the saved step stays
 *   as it was: closing at the start step, or with × on step 10, changes nothing.
 *
 * `changed` says whether anything needs writing.
 */
function closeTourOutcome(o) {
    const before = o.savedStep == null ? null : clampStep(o.savedStep);
    if (o.finished)
        return { lastStep: null, completed: true, changed: true };
    const step = clampStep(o.step);
    const keep = step > clampStep(o.startStep) && step < walkthroughCopy_1.WALKTHROUGH_STEP_COUNT;
    const lastStep = keep ? step : before;
    return { lastStep, completed: false, changed: lastStep !== before };
}
/**
 * @deprecated The pre-addendum rule (any close before step 10 saves). Web uses
 * `closeTourOutcome`; kept until mobile mirrors it, then deleted.
 *
 * What closing the overlay writes (E10): closing partway saves the step; reaching
 * step 10 is "finished" and clears it (the server then stamps completion, G5).
 */
function closeOutcome(step) {
    return step >= walkthroughCopy_1.WALKTHROUGH_STEP_COUNT
        ? { lastStep: null, completed: true }
        : { lastStep: clampStep(step), completed: false };
}
//# sourceMappingURL=walkthroughRules.js.map